const setStateBy = (scope, key) => (state, action) => {
  state[scope][key] = action.payload;
};

const setBaseState = (key, callback) => (state, action) => {
  state[key] = action.payload;
  callback?.(state, action);
};

const setEntitiesState = setStateBy.bind(null, 'entities');

export default setEntitiesState;

export { setStateBy, setBaseState };
